export function workoutThreadEventVersion(event = {}) {
  return [
    event.event_type || '',
    event.updated_at || '',
    event.occurred_at || '',
    event.activity_id || '',
  ].map(String).join(':');
}

export function shouldFetchInlineWorkoutThread({ cached = {}, event = {}, retry = false } = {}) {
  if (retry) return true;
  if (cached.loading) return false;
  return !cached.loaded || cached.eventVersion !== workoutThreadEventVersion(event);
}
